import { AnalyticsServices } from './AnalyticsServices';

export const customerServiceHeaders = ['Service', 'Service type', 'Service ID', 'Views', 'Last viewed (IST)', 'Added to cart', 'Current cart quantity', 'Last added (IST)', 'Booking result', 'Bookings'];
export const serviceBookingResult = (service) => service.bookings.length ? 'Booked' : service.current_cart_quantity > 0 ? 'In cart / no recorded booking' : service.added_to_cart ? 'Previously added / no recorded booking' : service.views ? 'Viewed / no recorded booking' : 'No recorded booking';
export const customerServiceValues = (service, indiaTime) => [service.name, service.type, service.service_id, service.views, indiaTime(service.last_viewed_at), service.added_to_cart ? 'Yes' : 'No', service.type === 'provider_service' ? service.current_cart_quantity : 'Not applicable', indiaTime(service.last_added_at), serviceBookingResult(service), service.bookings.map((booking) => `${booking.number || `Booking #${booking.id}`} · ${booking.status} · Qty ${booking.quantity} · ${indiaTime(booking.submitted_at)}`).join('\n')];

export async function customerServiceRows(people, baseRows, params, indiaTime, isCurrent) {
  const rows = [];
  for (let index = 0; index < people.length; index += 1) {
    const personId = Number(people[index].person_id);
    if (!Number.isSafeInteger(personId) || personId < 1) throw new Error('Could not load all customer service details. Please try again.');
    let count = 0;
    let total;
    for (let page = 1; total == null || count < total; page += 1) {
      if (!isCurrent()) return null;
      if (page > 10000) throw new Error('Export is too large. Choose a shorter date range.');
      const response = await AnalyticsServices.customerServices({ ...params, person_id: personId, page, limit: 100 });
      if (!isCurrent()) return null;
      const services = response?.data?.services;
      const pagination = response?.data?.pagination;
      if (response?.success !== 1 || !Array.isArray(services) || !Number.isInteger(pagination?.total) || pagination.total < 0) {
        throw new Error('Could not load all customer service details. Please try again.');
      }
      total = pagination.total;
      if (!services.length && count < total) throw new Error('Customer service details changed during export. Please try again.');
      for (const service of services) rows.push([...baseRows[index], 'Available', ...customerServiceValues(service, indiaTime)]);
      count += services.length;
    }
    if (!count) rows.push([...baseRows[index], 'No recorded service details', ...Array(customerServiceHeaders.length).fill('Unavailable')]);
  }
  return rows;
}
